import React from "react";
import { styled } from "styled-components";

interface IProps {
  src: any;
  title: string;
  subTitle: string;
}

const SubVisualWrap = styled.div`
  width: 100%;
  height: 260px;
  position: relative;
  @media all and (max-width: 768px) {
    height: 41.667vw;
  }
`;

const SubVisualImgWrap = styled.div`
  width: 100%;
  height: 100%;
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
  }
  > img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    object-fit: cover;
  }
`;

const SubVisualTextWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  div {
    display: flex;
    flex-direction: column;
    gap: 16px;
    span {
      font-size: 20px;
      line-height: 1.4;
      color: #fbfbfb;
      font-weight: bold;
      text-shadow: rgba(0, 0, 0, 0.4) 2px 0 2px;
    }
    p {
      font-size: 48px;
      line-height: 1.4;
      color: #fbfbfb;
      font-weight: bold;
      text-shadow: rgba(0, 0, 0, 0.4) 2px 0 2px;
    }
  }
  @media all and (max-width: 768px) {
    div {
      gap: 1.042vw;
      span {
        font-size: 3.646vw;
      }
      p {
        font-size: 6.771vw;
      }
    }
  }
`;

const SubVisual = ({ src, title, subTitle }: IProps) => (
  <SubVisualWrap
    data-aos="fade"
    data-aos-duration={600}
    data-aos-easing="linear"
  >
    <SubVisualImgWrap>
      <img src={src} alt="sub visual" />
    </SubVisualImgWrap>
    <SubVisualTextWrap>
      <div className="inner">
        <div>
          <span>{subTitle}</span>
          <p>{title}</p>
        </div>
      </div>
    </SubVisualTextWrap>
  </SubVisualWrap>
);

export default SubVisual;
